__turbopack_context__.v({
  "h6": "styles-module-scss-module__DXHeMq__h6",
});
